/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
        commit("UPDATE_SIDEBAR_WIDTH", width);
    },
    updateI18nLocale({ commit }, locale) {
        commit("UPDATE_I18N_LOCALE", locale);
    },
    toggleContentOverlay({ commit }) {
        commit("TOGGLE_CONTENT_OVERLAY");
    },
    updateTheme({ commit }, val) {
        commit("UPDATE_THEME", val);
    },
    updateAuthToken({ commit }, val) {
        commit("UPDATE_AUTH_TOKEN", val);
    },
    updateUser({ commit }, val) {
        commit("UPDATE_USER_INFO", val);
    },
    updateIsUpgradePlan({ commit }, val) {
        commit("UPDATE_IS_UPGRADE_PLAN", val);
    },
    updateLiveStatus({ commit }, val) {
        commit("UPDATE_LIVESTATUS_INFO", val);
    },

    updateNoOfUsers({ commit }, val) {
        commit("UPDATE_NO_OF_USERS", val);
    },

    updateUserSubscriptionPlan({ commit }, data) {
        commit("UPDATE_USER_SUBSCRIPTION_INFO", data);
    },

    updateUserDetails({ commit }, data) {
        commit("UPDATE_USER_DETAILS", data);
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit("UPDATE_STARRED_PAGE", payload);
    },
    updatePagination({ commit }, value) {
        commit("UPDATE_DASHBOARD_PAGINATION_WIDTH", value);
    }
};

export default actions;